import { render, staticRenderFns } from "./PaymentSuccessLab.vue?vue&type=template&id=5fb70a74&scoped=true"
import script from "./PaymentSuccessLab.vue?vue&type=script&lang=js"
export * from "./PaymentSuccessLab.vue?vue&type=script&lang=js"
import style0 from "./PaymentSuccessLab.vue?vue&type=style&index=0&id=5fb70a74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb70a74",
  null
  
)

export default component.exports